'use client';

import { createContext, useContext, ReactNode } from 'react';
import { DockviewApi } from 'dockview';

const DockviewApiContext = createContext<DockviewApi | null>(null);

export interface DockviewApiProviderProps {
  api: DockviewApi | null;
  children: ReactNode;
}

export function DockviewApiProvider({ api, children }: DockviewApiProviderProps) {
  return <DockviewApiContext.Provider value={api}>{children}</DockviewApiContext.Provider>;
}

export function useDockviewApi(): DockviewApi | null {
  return useContext(DockviewApiContext);
}
